import { Shape } from "three";
import { cache } from "../../cache";
export function createCircularShape(radius) {
    return cache(() => {
        const shape = new Shape();
        shape.moveTo(radius, 0);
        shape.absarc(0, 0, radius, 0, 2 * Math.PI, false);
        return shape;
    }, "createCircularShape", [radius]);
}
//# sourceMappingURL=createCircularShape.js.map